"use strict";
import Application      from "./Application";
import PreloaderScene   from "./PreloaderScene";
import Common           from "./Common";
import isMobile         from "ismobilejs";

export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {
        Common.assets = new P3.AssetManager();
        Common.audio = P3.Button.audio = new P3.AudioManager();
        Common.language = language;

        Common.loadMute();
        Common.loadGame();

        const isPortrait = false;

        const params = {};
        params.holderId = "game";
        params.width = this._width;
        params.height = this._height;
        params.portrait = isPortrait;
        params.aspectRatioFillHeight = !isPortrait;
        params.rotateImageUrl = "./assets/images/rotate_screen" + ".jpg";
        params.rotateImageColor = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        // PIXI.settings.MIPMAP_TEXTURES = false;//attempt to fix seams between tiles
        // PIXI.glCore.VertexArrayObject.FORCE_NATIVE = true; //attempted fix for flickering UI

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        TweenLite.lagSmoothing();//turn lag smoothing on

        const view = new P3.View(params);
        view.signals.ready.addOnce(function (canvas) {

            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1.0;
            // options.roundPixels = true;//again, attempts seams between tiles fix

            const stage = new PIXI.Container();
            Common.stage = stage;

            // const input = new Input();
            /// input.init(stage, canvas);
            // Common.input = input;

            //on clicking the document focus on canvas, fix for buttons not working on mobile
            document.onclick = () => {
                canvas.focus();
            };

            const renderer = PIXI.autoDetectRenderer(this._width, this._height, options);
            //  const renderer = new PIXI.WebGLRenderer(this._width, this._height, options);
            renderer.backgroundColor = 0x0;
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new P3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            PIXI.ticker.shared.add(function (deltaTime) {
                window.P3.deltaTime = window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                scene.update();
                renderer.render(Common.stage);
            }, this);

            /*
             const timestep = new p3.Timestep(p3.Timestep.FIXED);
             timestep.init(this.update, this.render, this);
             Common.timestep = timestep;
             */

            window.delay = function (callback, delay, scope) {
                TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            {name: "cn_preloader_1x", url: "images/" + "cn_preloader_1x" + ".json"},
            {name: "cn_preloader", url: "images/" + "cn_preloader" + ".jpg"},
            {name: "ui_1x", url: "images/" + "ui_1x" + ".json"}
        ];
        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function () {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();

            Common.audio.addSounds(sounds, [".ogg", ".m4a"], "");
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {

        const files = [
            //jpg
            {name: "splash_bg", url: "images/" + "splash_bg" + ".jpg"},
            {name: "game_over_bg", url: "images/" + "game_over_bg" + ".jpg"},
            {name: "gameplay_arena_bg", url: "images/" + "gameplay_arena_bg" + ".jpg"},

            //sheets
            {name: "game_0_1x", url: "images/" + "game_0_1x" + ".json"},
            {name: "ui_1x", url: "images/" + "ui_1x" + ".json"},
            {name: "tutorial_1x", url: "images/" + "tutorial_1x" + ".json"},
            //spine
            {name: "projectile_1", url: "images/" + "projectile_1" + ".json"},
            {name: "intro", url: "images/" + "intro" + ".json"},
            {name: "betty", url: "images/" + "betty" + ".json"},
            //particles
            {name: "part_life_meter", url: "particles/" + "part_life_meter" + ".json"},
            {name: "part_virus_1", url: "particles/" + "part_virus_1" + ".json"},
            {name: "part_virus_2", url: "particles/" + "part_virus_2" + ".json"},
            {name: "part_projectile_1", url: "particles/" + "part_projectile_1" + ".json"},
            {name: "part_burst", url: "particles/" + "part_burst" + ".json"},
            {name: "part_hit_shot", url: "particles/" + "part_hit_shot" + ".json"},
            {name: "part_missed_shot", url: "particles/" + "part_missed_shot" + ".json"},
            {name: "part_virus_drift", url: "particles/" + "part_virus_drift" + ".json"},
            {name: "part_emitter_heart", url: "particles/" + "part_emitter_heart" + ".json"},
            //data
            {name: "copy", url: "data/" + "copy" + ".json"},
            {name: "path_test", url: "data/paths/" + "path_test" + ".json"},
            {name: "config", url: "data/" + "config" + ".json"}
        ];

        const sounds = [
            "sfx_btn_select",
            "sfx_btn_rollover",
            "sfx_ambient_loop_00",
            "sfx_ambient_popup_loop_00",
            "sfx_deflectshot",
            "sfx_empty_00",
            "sfx_enemyfire",
            "sfx_enemyhit",
            "sfx_gameover",
            "sfx_realwendyhit",
            "sfx_playerhit",
            "sfx_linealert",
            "sfx_firelaser1",
            "sfx_firelaser2",
            "sfx_firelaser3",
            "sfx_reload_00",
            "sfx_heart_throw_00",
            "sfx_heart_pickup_2",

            "music_gameover_music_sting_00",
            "music_gameplay_loop_00",
            "music_menu_loop_00",
            "music_menu_loop_start_00",
            "music_results_loop_00"
        ];

        if (files.length) {
            this._preloader = new PreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();

            Common.audio.addSounds(sounds, [".ogg", ".m4a"], "assets/audio/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;

        const config = {};
        Common.config = config;
    }

    startGame() {
        delay(function () {
            new Application();
            Application.init();
        }, 1.0, this);
    }

    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();

        this._preloader.loaded = 1;

        if (isMobile.any) {
            this._preloader.signals.next.add(function () {
                this.startGame(0);
            }, this);
        } else {
            this.startGame(1);
        }
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(P3.View.width, P3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}

window.Main = Main;

/**
 *
 * @param texture
 * @param holder
 * @returns {PIXI.Sprite}
 */
function createSprite(texture, holder, anchor) {
    let sprite;
    anchor = anchor || new PIXI.Point(0.5, 0);
    if (typeof texture === "string") {
        sprite = new PIXI.Sprite(Common.assets.texture(texture));
    } else if (texture instanceof PIXI.Texture) {
        sprite = new PIXI.Sprite(texture);
    } else {
        console.warn("texture neither a string nor a PIXI.Texture, falling back to empty texture");
        sprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
    }
    sprite.anchor = anchor;
    if (holder) holder.addChild(sprite);
    return sprite;
}
P3.createSprite = createSprite;

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */
function simpleText(copy, fontName, size, holder, colour) {
    const col = colour || 0x000000;
    const textView = new PIXI.Text(copy, {fontFamily: fontName, fontSize: size, fill: col});
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    return textView;
}
P3.simpleText = simpleText;

function createText(copy, config, type) {
    const cfg = {};
    let textView;
    if (Common.language === "ar") {

    } else {

        if (!type) cfg.fontFamily = "Fred Fredburger Headline Black";
        else cfg.fontFamily = type;
        cfg.fontSize = config.size || config.fontSize || 25;
        cfg.fill = config.fill || 0x0;
        cfg.align = config.align || "left";
        cfg.letterSpacing = config.letterSpacing || 0;
        if (config.stroke) {
            cfg.stroke = config.stroke;
            cfg.strokeThickness = config.strokeThickness || 5;
        }
        if (config.wordWrap || cfg.wordWrapWidth) {
            cfg.wordWrap = true;
            cfg.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.dropShadow || cfg.dropShadowDistance) {
            cfg.dropShadow = true;
            cfg.dropShadowDistance = config.dropShadowDistance || 5;
        }

        textView = new PIXI.Text(copy, cfg);
    }
    return textView;
}
window.createText = createText;

/**
 * Creates the texture for the popups sprite
 * @param width
 * @param height
 * @returns {Texture|PIXI.Texture}
 */
function createPopUpTexture(width, height) {
    let g = new PIXI.Graphics();
    g.beginFill(0xffffff);
    g.lineStyle(25, 0xe1e1e1);
    g.drawRoundedRect(0, 0, width, height, 10);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    g.destroy();
    return texture;
}

/**
 * Creates a popup screen sprite
 * @param width {number}
 * @param height {number}
 * @param centre {boolean}
 * @param holder {PIXI.Container}
 * @returns {PIXI.Sprite}
 */
function createPopup(width, height, centre, holder) {
    let sc = new PIXI.Sprite(createPopUpTexture(width, height));
    sc.anchor.set(0.5);
    if (centre) sc.y = P3.View.height * 0.5;
    if (holder) holder.addChild(sc);
    Common.generatedDispObjs.push(sc);
    return sc;
}
P3.createPopup = createPopup;

/**
 * Depths sorts children in container passed to it by x, y coordinates
 * @param container {PIXI.Container}
 */
function depthSortXY(container) {
    container.children.sort(function (a, b) {
        return a.position.y > b.position.y ? 1 : a.position.y < b.position.y ? -1 : a.position.x > b.position.x ? 1 : a.position.x < b.position.x ? -1 : 0
    });
}
P3.depthSortXY = depthSortXY;

/**
 * Depth sorts children by y value
 * @param container
 */
function depthSortY(container) {
    container.children.sort(function (a, b) {
        //if (a.floor || b.floor) return -1;//don't sort floor
        if (a.y === b.y) {//bit of weirdness to handle z fighting
            b.y -= 0.1;
            return 1;
        }
        if (a.y > b.y) {
            return 1;
        }
        return -1;
    });
}
P3.depthSortY = depthSortY;

/**
 * TODO - swap for built in sort function, my tests show it is much quicker
 * Depth sorts children by z value (must assign a z value to the display object for this to work)
 * @param container
 * @param highToLow {?boolean}
 */
function depthSortZ(container, highToLow) {
    highToLow = highToLow || true;
    const array = container.children;
    const len = array.length - 1;
    quickSort(0, len);

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i].z < pivot.z) swap(index++, i);
                else if (highToLow && array[i].z > pivot.z) swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
}
P3.depthSortZ = depthSortZ;

/**
 * @deprecated
 * Creates and returns a new UI button
 * @param point {PIXI.Point}
 * @param type
 * @param callback
 * @param scope
 * @param params
 * @returns {Button}
 */
function createButton(point, type, callback, scope, params = {holder: null, text: null, icon: null}) {

    const states = new P3.ButtonStates();

    if (params.text || !type) {
        states.normal = PIXI.Texture.EMPTY;
        states.down = PIXI.Texture.EMPTY;
    } else if (typeof type === "string") {
        states.normal = Common.assets.texture("btn_" + type + "_out");
        states.over = Common.assets.texture("btn_" + type + "_over");
        states.down = Common.assets.texture("btn_" + type + "_down");
    } else {
        states.normal = type;
    }
    const button = new Button(states);
    button.x = point.x;
    button.y = point.y;
    button.anchor = new PIXI.Point(0.5, 0.5);
    button.animate = true;

    button.signals.click.add(callback, scope);

    if (params) {
        if (params.holder) {
            params.holder.addChild(button);
        }
        if (params.icon) {
            let sp = P3.createSprite(params.icon);
            sp.anchor.set(0.5);
            button.addChild(sp);
            button.icon = sp;
        }
        if (params.text) {
            let txtView = P3.simpleText(params.text, "consolas", 45, button, 0xffffff);//new PIXI.extras.BitmapText(text, {font: "45px Calibri"});
            txtView.anchor = {x: 0.5, y: 0.5};
            button.txtView = txtView;
        }
    }

    return button;
}
P3.createButton = createButton;

function simpleButton(type, icon, cb, ctx) {

    const assets = Common.assets;

    let btn;
    if (icon) {
        btn = P3.Button.create(
            assets.texture("btn_" + type + "_out"),
            assets.texture("btn_" + type + "_over"),
            assets.texture("btn_" + type + "_down"),
            assets.texture("icon_" + icon)
        );
    } else {
        btn = P3.Button.create(
            assets.texture("btn_" + type + "_out"),
            assets.texture("btn_" + type + "_over"),
            assets.texture("btn_" + type + "_down")
        );
    }

    btn.overSoundName = "sfx_btn_rollover";
    btn.clickSoundName = "sfx_btn_select";
    btn.signals.click.add((e) => {
        cb(e);
    }, ctx);

    return btn;
}
P3.simpleButton = simpleButton;

function simpleMute() {

    const assets = Common.assets;

    const states = new P3.ButtonStates();
    states.normal = assets.texture("btn_small_out");
    states.over = assets.texture("btn_small_over");
    states.up = assets.texture("btn_small_down");
    states.icon = assets.texture("icon_sound_on");
    states.iconAlt = assets.texture("icon_sound_off");

    const btn = new P3.MuteButton(states);
    btn.overSoundName = "sfx_btn_rollover";
    btn.clickSoundName = "sfx_btn_select";

    if (Common.isMute) {//if is mute switch to muted icon on creation
        btn._icon.texture = assets.texture("icon_sound_off");
    }

    return btn;
}
P3.simpleMute = simpleMute;

/**
 * Create and returns new particle emitter
 * @param holder {PIXI.Container}
 * @param configName {String}
 * @param tex {Object}
 * @param arr {Array}
 * @param emit {boolean} @default {true}
 * @returns {PIXI.particles.Emitter}
 */
function createParticles(holder, configName, tex, arr, emit) {
    const assets = Common.assets;
    const textures = [];
    for (let i = 1; i <= tex.count; i++) {
        textures.push(assets.texture(tex.name + i));
    }
    const config = assets.json(configName);
    const emitter = new PIXI.particles.Emitter(holder, textures, config);
    if (arr) arr.push(emitter);
    emitter.emit = emit || true;
    return emitter;
}
P3.createParticles = createParticles;

/**
 * @param name {string}
 * @param startAnim {string}
 * @param autoUpdate {boolean}
 * @returns {*|Spine}
 */
function createSpine(name, startAnim, autoUpdate, loop = true) {
    autoUpdate = autoUpdate || false;
    const spine = new PIXI.spine.Spine(Common.assets.spineData(name));
    spine.skeleton.setToSetupPose();
    spine.autoUpdate = autoUpdate;
    if (startAnim) {
        spine.state.setAnimation(0, startAnim, loop);
    }
    spine.update(0);
    return spine;
}
P3.createSpine = createSpine;

